<template>
    <div class="wb-sidebar-menu"
         ref="menuContainer"
         v-on:scroll="scrollComputeHandler()">
        <SidebarCategoriesScroll :direction="'up'"
                                 :width="'408px'"
                                 v-show="showTopScroll"
                                 v-on:click="scrollByClick(-1)"/>

        <div class="wb-sidebar-menu-list">
            <SidebarMenuLabel :text="'Комплектация'"/>
            <div class="wb-sidebar-menu-group">
                <div v-for="item of getItemsResult" :key="item.id">
                    <div class="wb-c-grey-line-h"></div>
                    <SidebarMenuItem :data="item" :component-type="'4'"/>
                </div>
            </div>
          <SidebarMenuLabel :text="'Новинки'" v-if="Object.entries(storeData.getAccessoriesByCategoryId(178)).length"/>
          <div class="wb-sidebar-menu-group" >
            <div v-for="[id, count] of Object.entries(getAccessoriesByCategoryId(178))" :key="id">
              <div class="wb-c-grey-line-h"></div>
              <SidebarMenuItem :id-arr="id" :data="{...JSON.parse(JSON.stringify(storeData.getItemsByIdArr([+id])[0])), count}" :component-type="'3'"/>
            </div>
          </div>
          <SidebarMenuLabel :text="'Аксессуары'" v-if="Object.entries(getAccessoriesByCategoryId(22)).length"/>
          <div class="wb-sidebar-menu-group">
            <div v-for="[id, count] of Object.entries(getAccessoriesByCategoryId(22))" :key="id">
              <div class="wb-c-grey-line-h"></div>
              <SidebarMenuItem :id-arr="id" :data="{...JSON.parse(JSON.stringify(storeData.getItemsByIdArr([+id])[0])), count}" :component-type="'3'"/>
            </div>
          </div>
        </div>
       <div class="wb-sidebar-result-list">
         <SidebarResultFooter :items="getItemsResult"  @open-accessories="storeData.setActiveCategory(categoriesSections.catalog, 22)"/>
       </div>
        <SidebarCategoriesScroll :direction="'down'"
                                 :width="'408px'"
                                 v-show="showBotScroll"
                                 v-on:click="scrollByClick(1)"/>
    </div>
</template>

<script>
import SidebarCategoriesScroll from '@/UI/Components/ComponentsSidebarCategories/SidebarCategoriesScroll.vue';
import SidebarMenuLabel from '@/UI/Components/ComponentsSidebarMenu/SidebarMenuLabel.vue';
import SidebarMenuItem from '@/UI/Components/ComponentsSidebarMenu/SidebarMenuItem.vue';
import { demoMenuItems } from '@/Constants/demoData';
import { useStoreData } from '@/Store/storeData';
import { useConfigurationStore } from '@/Store/storeConfiguration';
import { computeCost } from '@/lib/computeCost';
import SidebarResultFooter from '@/UI/Components/ComponentsSidebarResult/SidebarResultFooter.vue';
import { categoriesSections } from '@/Constants/common';
import { getItemsResult } from '@/lib/getItemsResult';

export default {
    name: 'TheSidebarMenu',
    components: {
      SidebarResultFooter,
        SidebarMenuItem,
        SidebarMenuLabel,
        SidebarCategoriesScroll,
    },
    setup() {
        const storeData = useStoreData();
        const storeConfiguration = useConfigurationStore();
        return {
            storeData,
            storeConfiguration,
        };
    },
    data() {
        return {
            items: demoMenuItems,
            scrollHeight: 0,
            scrollTop: 0,
            containerHeight: 0,
            scrollStep: 113,
        };
    },

    computed: {
      categoriesSections() {
        return categoriesSections;
      },
        showTopScroll() {
            return this.scrollTop > 0;
        },
        showBotScroll() {
            return this.scrollHeight > this.containerHeight + this.scrollTop;
        },
        getItemsResult() {
            return getItemsResult();
        },
        getAccessoriesByCategoryId() {
            return (categoryId) => {
                const manualAccessories = this.storeData.getAccessoriesByCategoryId(categoryId);
                const allItemIDs = this.storeConfiguration.getAllItemIDs;

                const result = { ...manualAccessories };
                const category = this.storeData.getCategories.find(cat => cat.id === categoryId);
                if (category) {
                    const categoryItemIds = [ ...(category.items || []) ];
                    if (category.sections) {
                        category.sections.forEach(section => {
                            if (section.items) {
                                categoryItemIds.push(...section.items);
                            }
                        });
                    }

                    allItemIDs.forEach(id => {
                        if (categoryItemIds.includes(+id)) {
                            result[id] = (result[id] || 0) + 1;
                        }
                    });

                    // Если категория 22 (Аксессуары), исключаем товары, которые уже есть в 178 (Новинки)
                    if (categoryId === 22) {
                        const newItems = this.getAccessoriesByCategoryId(178);
                        Object.keys(newItems).forEach(id => {
                            delete result[id];
                        });
                    }
                }

                return result;
            };
        },
    },
    methods: {
        scrollComputeHandler() {
            this.scrollHeight = this.getScrollHeight();
            this.scrollTop = this.getScrollTop();
            this.containerHeight = this.getContainerHeight();
        },
        getScrollHeight() {
            return this.$refs.menuContainer?.scrollHeight;
        },
        getScrollTop() {
            return this.$refs.menuContainer?.scrollTop;
        },
        getContainerHeight() {
            return this.$refs.menuContainer?.clientHeight;
        },
        scrollByClick(direction) {
            // TODO add smooth animation
            this.$refs.menuContainer.scrollTop = this.$refs.menuContainer.scrollTop + direction * this.scrollStep;
        },
    },
    mounted() {
        this.scrollComputeHandler();
        window.addEventListener('resize', this.scrollComputeHandler);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.scrollComputeHandler);
    },
};
</script>

<style scoped lang="scss">
@import "CSS/colors.scss";
@import "CSS/common.scss";

.wb-sidebar-result-list {
  padding: 0 16px 60px;
  display: flex;
  flex-direction: column;
}
.wb-sidebar-menu {
    width: 408px;
    height: 100%;
    box-sizing: border-box;
    overflow-y: auto;
    overflow-x: hidden;
    background-color: $white;


    -ms-overflow-style: none;
    scrollbar-width: none;
}

.wb-sidebar-menu::-webkit-scrollbar {
    display: none;
}

.wb-sidebar-menu-list {
    padding: 24px 16px;
    display: flex;
    flex-direction: column;
}

.wb-sidebar-menu-group {
    display: flex;
    flex-direction: column;
    height: max-content;
    width: 100%;
    box-sizing: border-box;
}
</style>
